module.exports = __webpack_public_path__ + "img/AgeTabBackground_ua.1c86f180.webp";